// extracted by mini-css-extract-plugin
export default {"ViewModeSwitch":"Styles_ViewModeSwitch__jJN9-"};